import { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { FaBars, FaTimes, FaChevronDown } from 'react-icons/fa';
import './Header.css';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`site-header ${isSticky ? 'sticky' : ''}`}>
      <div className="navbar-surface">
        <div className="container">
          <div className="header-inner">
            <div className="site-logo">
            <Link to="/" onClick={closeMobileMenu} className="site-logo-link" aria-label="Al-Noor Tutors Academy — Home">
              <img src="/logo.png" alt="Al-Noor Tutors Academy" className="site-logo-img" width="400" height="88" />
            </Link>
            </div>

            <nav className={`main-navigation ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
            <ul className="main-menu">
              <li><NavLink to="/" onClick={closeMobileMenu}>Home</NavLink></li>
              
              <li className="menu-item-has-children menu-item-has-nested">
                <a href="#courses">Courses <FaChevronDown /></a>
                <ul className="sub-menu">
                  <li className="menu-item-has-children">
                    <Link to="/courses#qaida" onClick={closeMobileMenu}>Qaida Courses <FaChevronDown /></Link>
                    <ul className="sub-menu nested-submenu">
                      <li><NavLink to="/courses/noorani-qaida-course" onClick={closeMobileMenu}>Noorani Qaida Course</NavLink></li>
                      <li><NavLink to="/courses/madani-qaida-course" onClick={closeMobileMenu}>Madani Qaida Course</NavLink></li>
                      <li><NavLink to="/courses/baghdadi-qaida-course" onClick={closeMobileMenu}>Baghdadi Qaida Course</NavLink></li>
                      <li><NavLink to="/courses/rehmani-qaida-course" onClick={closeMobileMenu}>Rehmani Qaida Course</NavLink></li>
                    </ul>
                  </li>
                  <li className="menu-item-has-children">
                    <Link to="/courses#quran-reading" onClick={closeMobileMenu}>Quran Reading Course <FaChevronDown /></Link>
                    <ul className="sub-menu nested-submenu">
                      <li><NavLink to="/courses/nazra-quran-course" onClick={closeMobileMenu}>Nazra Quran Course</NavLink></li>
                      <li><NavLink to="/courses/quran-memorization-course" onClick={closeMobileMenu}>Quran Memorization Course</NavLink></li>
                      <li><NavLink to="/courses/quran-reading-course" onClick={closeMobileMenu}>Quran Reading Course</NavLink></li>
                    </ul>
                  </li>
                  <li className="menu-item-has-children">
                    <Link to="/courses#quran-recitation" onClick={closeMobileMenu}>Quran Recitation Course <FaChevronDown /></Link>
                    <ul className="sub-menu nested-submenu">
                      <li><NavLink to="/courses/quran-recitation-course" onClick={closeMobileMenu}>Quran Recitation Course</NavLink></li>
                      <li><NavLink to="/courses/ten-qirat-course" onClick={closeMobileMenu}>Ten Qiraat Course</NavLink></li>
                      <li><NavLink to="/courses/ijazah-course" onClick={closeMobileMenu}>Quran Ijazah Course</NavLink></li>
                      <li><NavLink to="/courses/tajweed-course" onClick={closeMobileMenu}>Tajweed Course</NavLink></li>
                    </ul>
                  </li>
                  <li className="menu-item-has-children">
                    <Link to="/courses#quran-translation" onClick={closeMobileMenu}>Quran Translation Course <FaChevronDown /></Link>
                    <ul className="sub-menu nested-submenu">
                      <li><NavLink to="/courses/tafseer-course" onClick={closeMobileMenu}>Tafseer Course</NavLink></li>
                      <li><NavLink to="/courses/quran-translation-course" onClick={closeMobileMenu}>Quran Translation Course</NavLink></li>
                    </ul>
                  </li>
                  <li className="menu-item-has-children">
                    <Link to="/courses#islamic-studies" onClick={closeMobileMenu}>Islamic Studies Course <FaChevronDown /></Link>
                    <ul className="sub-menu nested-submenu">
                      <li><NavLink to="/courses/fundamentals-of-islam-course" onClick={closeMobileMenu}>Fundamentals Of Islam Course</NavLink></li>
                      <li><NavLink to="/courses/islamic-studies-course" onClick={closeMobileMenu}>Islamic Studies Course</NavLink></li>
                      <li><NavLink to="/courses/namaz-course" onClick={closeMobileMenu}>Namaz Course</NavLink></li>
                      <li><NavLink to="/courses/6-kalma-course" onClick={closeMobileMenu}>6 Kalma Course</NavLink></li>
                      <li><NavLink to="/courses/janaza-course" onClick={closeMobileMenu}>Janaza Course</NavLink></li>
                    </ul>
                  </li>
                  <li><NavLink to="/courses/hadith-course" onClick={closeMobileMenu}>Hadith Course</NavLink></li>
                  <li className="menu-item-has-children">
                    <Link to="/courses#arabic-speaking" onClick={closeMobileMenu}>Arabic Speaking Course <FaChevronDown /></Link>
                    <ul className="sub-menu nested-submenu">
                      <li><NavLink to="/courses/arabic-language-course" onClick={closeMobileMenu}>Arabic Language Course</NavLink></li>
                      <li><NavLink to="/courses/arabic-grammar-course" onClick={closeMobileMenu}>Arabic Grammar Course</NavLink></li>
                    </ul>
                  </li>
                  <li><NavLink to="/courses" onClick={closeMobileMenu}>Explore All Courses</NavLink></li>
                </ul>
              </li>

              <li><NavLink to="/become-a-teacher" onClick={closeMobileMenu}>Become A Teacher</NavLink></li>
              
              <li className="menu-item-has-children">
                <a href="#fee">Fee <FaChevronDown /></a>
                <ul className="sub-menu">
                  <li><NavLink to="/study-plans-fees" onClick={closeMobileMenu}>Fee Plans</NavLink></li>
                  <li><NavLink to="/payment-options" onClick={closeMobileMenu}>Payment Options</NavLink></li>
                </ul>
              </li>

              <li className="menu-item-has-children">
                <a href="#teachers">Teachers <FaChevronDown /></a>
                <ul className="sub-menu">
                  <li><NavLink to="/our-teachers" onClick={closeMobileMenu}>Our Teachers</NavLink></li>
                </ul>
              </li>

              <li className="menu-item-has-children">
                <a href="#contact">Contact <FaChevronDown /></a>
                <ul className="sub-menu">
                  <li><NavLink to="/contact-us" onClick={closeMobileMenu}>Contact Us</NavLink></li>
                  <li><NavLink to="/about-us" onClick={closeMobileMenu}>About Us</NavLink></li>
                </ul>
              </li>

              <li><NavLink to="/free-trial" onClick={closeMobileMenu}>Free Trial</NavLink></li>
              {/* <li><NavLink to="/blog" onClick={closeMobileMenu}>Blog</NavLink></li> */}
            </ul>
            </nav>

            <div className="mobile-menu-toggle" onClick={toggleMobileMenu}>
              {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
              <span className="menu-text">{isMobileMenuOpen ? 'Close' : 'Menu'}</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
